import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Typography, Table, Input  } from 'antd';
import { useHistory } from 'react-router-dom';
import {FileExcelOutlined, LeftOutlined} from '@ant-design/icons';
import { 
    collection,
    onSnapshot, doc,
    query as queryFirebase, where,
 } from 'firebase/firestore';

import { useQuery } from '../../hooks';
import { firestore } from '../../services/firebase';
import AppLoading from '../../components/AppLoading';
import { formatDate } from '../../utilities/';
import {CSVLink} from "react-csv";

const Visitas = () => {

    const {Search} = Input;
    const {Title} = Typography;
    const history = useHistory();
    const query = useQuery();
    const id = query.get("id");

    const [loading, setLoading] = useState(true);
    const [video, setVideo] = useState([]);
    const [visitasData, setVisitasData] = useState([]);
    const [filteredResults, setFilteredResults] = useState([]);
    const [searchInput, setSearchInput] = useState('');

    useEffect(() => {
        let mounted = true;
        if (mounted) {
            setTimeout(async () => {
                const q = queryFirebase(collection(firestore, "contador"), where("idVideo", "==", id));
                onSnapshot(q, (querySnapshot) => {
                    const visitas = [];
                    querySnapshot.forEach((doc) => {
                        if (doc.data().idUsuario) {
                            visitas.push(doc.data());
                        }
                    });
                    setVisitasData(visitas);
                    setLoading(false);
                });
            }, 0)

            onSnapshot(doc(firestore, "videos", id), (doc) => {
                setVideo(doc.data())
            });
        }
        return () => {
            mounted = false
        };
    }, [id]);

    const onSearch = (searchValue) => {
        setSearchInput(searchValue)
        if (searchValue !== '') {
            const filteredData = visitasData.filter((item) => {
                return Object.values(item.usuario_info).join('').toLowerCase().includes(searchValue.toLowerCase());
            })
            setFilteredResults(filteredData)
        } else {
            setFilteredResults(visitasData)
        }
    };

    const columns = [
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'fecha_visita',
            render: (index, item) => (formatDate(item?.fecha_visita?.toDate()))
        },
        {
            title: 'IP',
            dataIndex: 'nombre',
            key: 'nombre',
            render: (index, item) => (item.ipUsuario)
        },
        {
            title: 'Nomnbre',
            dataIndex: 'nombre',
            key: 'nombre',
            render: (index, item) => (item.usuario_info.nombre)
        },
        {
            title: 'Apellidos',
            dataIndex: 'apellidos',
            key: 'apellidos',
            render: (index, item) => (item.usuario_info.apellidos)
        },
        {
            title: 'Correo',
            dataIndex: 'correo',
            key: 'correo',
            render: (index, item) => (item.usuario_info.correo)
        },
        {
            title: 'Empresa',
            dataIndex: 'empresa',
            key: 'empresa',
            render: (index, item) => (item.usuario_info.empresa)
        },
        {
            title: 'Ocupación',
            dataIndex: 'ocupacion',
            key: 'ocupacion',
            render: (index, item) => (item.usuario_info.ocupacion)
        },
        {
            title: 'País',
            dataIndex: 'pais',
            key: 'pais',
            render: (index, item) => (item.usuario_info.pais)
        },
        {
            title: 'Teléfono',
            dataIndex: 'telefono',
            key: 'telefono',
            render: (index, item) => (item.usuario_info.telefono)
        },

    ];
    let headersExcel = [
        {label: 'Nombre', key: 'usuario_info.nombre'},
        {label: 'Apellidos', key: 'usuario_info.apellidos'},
        {label: 'País', key: 'usuario_info.pais'},
        {label: 'Ciudad', key: 'usuario_info.ciudad'},
        {label: 'Empresa', key: 'usuario_info.empresa'},
        {label: 'Teléfono', key: 'usuario_info.telefono'},
        // { label: 'Fecha de rgistro', key: 'registro' },
        {label: 'Correo electroóico', key: 'usuario_info.correo'},
        {label: 'Ocupación', key: 'usuario_info.ocupacion'},
    ];

    console.log(visitasData);
    if( loading ) { return <AppLoading /> }

    return (
        <>
            <Row gutter={{ xs: 10, sm: 10, md: 10, lg: 10}}>
                <Col
                    xs={{  span: 24, offset: 0 }} 
                    sm={{  span: 13, offset: 0 }} 
                    md={{  span: 12, offset: 0 }} 
                    lg={{  span: 12, offset: 0 }}  
                    xxl={{ span: 12, offset: 0 }}
                >
                    <Title level={4}>{video.nombre}</Title>
                </Col>
                <Col
                    xs={{  span: 24, offset: 0 }} 
                    sm={{  span: 7, offset: 4 }} 
                    md={{  span: 5, offset: 0 }} 
                    lg={{  span: 4, offset: 4 }}  
                    xxl={{ span: 4, offset: 5  }}
                >
                    <CSVLink
                      filename={video.nombre + ".csv"}
                      data={visitasData}
                      headers={headersExcel}
                    >
                        <Button size="large" block type="dashed" icon={<FileExcelOutlined/>}>
                            Excel
                        </Button>
                    </CSVLink>
                </Col>
                <Col
                    xs={{  span: 24, offset: 0 }} 
                    sm={{  span: 7, offset: 4 }} 
                    md={{  span: 5, offset: 2 }} 
                    lg={{  span: 4, offset: 0 }}  
                    xxl={{ span: 3, offset: 0  }}
                >
                    <Button 
                        type='primary'
                        size="large"
                        onClick={ () => history.goBack() }
                        block
                        icon={ <LeftOutlined /> }
                        >Volver
                    </Button>
                </Col>

                <Col
                  xs={{  span: 24, offset: 0 }}
                  sm={{  span: 24, offset: 0 }}
                  md={{  span: 24, offset: 0 }}
                  lg={{  span: 24, offset: 0 }}
                  xxl={{ span: 24, offset: 0 }}
                >
                    <Search
                      size="large"
                      placeholder="Buscar"
                      onSearch={onSearch}
                      style={{ width: '100%' }}
                    />
                </Col>
            </Row>

            <Table
                style={{ marginTop: 30 }}
                columns={columns}
                dataSource={ searchInput.length > 1 ? filteredResults : visitasData }
                rowKey="fecha_visita"
                loading={loading}
                scroll={{ x: 1300 }}
            />
        </>
    )
}

export default Visitas
